<div id="topbase" [ngClass]="!isFiltrati ? 'top__base' : ''">
  <div
    class="wrapper hidden__desktop"
    [ngClass]="pacchettoSelezionato ? 'selezionato' : ''"
  >
    <div
      class="pacchetto"
      *ngFor="let pacchetto of pacchettiFiltered; let idx = index"
      id="pacchetto__{{ idx }}"
    >
      <div class="item">
        <a
          class="item__primary__card"
          *ngIf="
            !pacchettoSelezionato || pacchettoSelezionato.id != pacchetto.id
          "
          (click)="apriDettaglioPacchetto($event, pacchetto, idx)"
          href="#pacchettoo__{{ idx }}"
        >
          <ng-container>
            <img
              [src]="pacchetto.imgsrc"
              alt="Immagine pacchetto {{ pacchetto.nome }}"
              title="Immagine pacchetto {{ pacchetto.nome }}"
              class="item__img"
            />
            <div class="item__content">
              <div>
                <div
                  class="associata desktop"
                  *ngIf="pacchetto.associate && pacchetto.associate_sconto != 0"
                >
                  <div>
                    <span *ngIf="pacchetto.associate_sconto == 100">
                      {{ "base.visita_inclusa_tot" | translate }}
                    </span>
                    <span
                      *ngIf="
                        pacchetto.associate_sconto != 100 &&
                        pacchetto.associate_sconto != 0
                      "
                    >
                      {{
                        "base.visita_inclusa_parziale"
                          | translate : { value: pacchetto.associate_sconto }
                      }}
                    </span>
                  </div>
                </div>
                <h4 class="nome mb-0">
                  {{ pacchetto.titolo | titlecase }}
                </h4>
                <div
                  class="associata mobile"
                  *ngIf="pacchetto.associate && pacchetto.associate_sconto != 0"
                >
                  <div>
                    <span *ngIf="pacchetto.associate_sconto == 100">
                      {{ "base.visita_inclusa_tot" | translate }}
                    </span>
                    <span
                      *ngIf="
                        pacchetto.associate_sconto != 100 &&
                        pacchetto.associate_sconto != 0
                      "
                    >
                      {{
                        "base.visita_inclusa_parziale"
                          | translate : { value: pacchetto.associate_sconto }
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="item__bottom">
                <div class="item__price">
                  <div class="prezzo base" *ngIf="!pacchetto.hasSconto()">
                    <span class="valuta">€</span>
                    <span>
                      {{ pacchetto.costo | number : "1.2-2" }}
                    </span>
                  </div>
                  <div class="prezzo barrato" *ngIf="pacchetto.hasSconto()">
                    <span class="valuta">€</span>
                    <span>
                      {{ pacchetto.costo | number : "1.2-2" }}
                    </span>
                  </div>
                  <div class="prezzo scontato" *ngIf="pacchetto.hasSconto()">
                    <div>
                      <span class="valuta">€</span>
                      <span>
                        {{
                          pacchetto.choosePrezzoScontato() | number : "1.2-2"
                        }}
                      </span>
                    </div>
                    <div *ngIf="!pacchetto.hasSconto()">&nbsp;</div>
                  </div>
                </div>
                <span class="material-symbols-outlined mt-1">
                  shopping_cart
                </span>
              </div>
            </div>
          </ng-container>
        </a>
        <div
          class="item__detail__card"
          *ngIf="
            pacchettoSelezionato && pacchettoSelezionato.id == pacchetto.id
          "
        >
          <ng-container>
            <app-dettaglio-pacchetto
              [pacchetto]="pacchettoSelezionato"
              [linguaCorrente]="linguaCorrente"
              [codiceForm]="codiceForm"
              [pacchettoSelezionato]="pacchettoSelezionato"
              [canBack]="true"
              [fromBase]="true"
              [idx]="idxSelezionato"
              (goBack)="goBack()"
            >
            </app-dettaglio-pacchetto>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div
    class="wrapper hidden__mobile"
    *ngIf="
      !pacchettoSelezionato && pacchettiFiltered && pacchettiFiltered.length > 0
    "
  >
    <div
      class="pacchetto"
      id="pacchetto__{{ idx }}"
      *ngFor="let pacchetto of pacchettiFiltered; let idx = index"
    >
      <div class="item">
        <a
          class="item__primary__card"
          *ngIf="
            !pacchettoSelezionato || pacchettoSelezionato.id != pacchetto.id
          "
          (click)="apriDettaglioPacchetto($event, pacchetto, idx)"
          href="#pacchettoo__{{ idx }}"
        >
          <ng-container>
            <img
              [src]="pacchetto.imgsrc"
              alt="Immagine pacchetto {{ pacchetto.nome }}"
              title="Immagine pacchetto {{ pacchetto.nome }}"
              class="item__img"
            />
            <div class="item__content">
              <div>
                <div
                  class="associata desktop"
                  *ngIf="pacchetto.associate && pacchetto.associate_sconto != 0"
                >
                  <div>
                    <span *ngIf="pacchetto.associate_sconto == 100">
                      {{ "base.visita_inclusa_tot" | translate }}
                    </span>
                    <span
                      *ngIf="
                        pacchetto.associate_sconto != 100 &&
                        pacchetto.associate_sconto != 0
                      "
                    >
                      {{
                        "base.visita_inclusa_parziale"
                          | translate : { value: pacchetto.associate_sconto }
                      }}
                    </span>
                  </div>
                </div>
                <h4 class="nome mb-0">
                  {{ pacchetto.titolo | titlecase }}
                </h4>
                <div
                  class="associata mobile"
                  *ngIf="pacchetto.associate && pacchetto.associate_sconto != 0"
                >
                  <div>
                    <span *ngIf="pacchetto.associate_sconto == 100">
                      {{ "base.visita_inclusa_tot" | translate }}
                    </span>
                    <span
                      *ngIf="
                        pacchetto.associate_sconto != 100 &&
                        pacchetto.associate_sconto != 0
                      "
                    >
                      {{
                        "base.visita_inclusa_parziale"
                          | translate : { value: pacchetto.associate_sconto }
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="item__bottom">
                <div class="item__price">
                  <div class="prezzo base" *ngIf="!pacchetto.hasSconto()">
                    <span class="valuta">€</span>
                    <span>
                      {{ pacchetto.costo | number : "1.2-2" }}
                    </span>
                  </div>
                  <div class="prezzo barrato" *ngIf="pacchetto.hasSconto()">
                    <span class="valuta">€</span>
                    <span>
                      {{ pacchetto.costo | number : "1.2-2" }}
                    </span>
                  </div>
                  <div class="prezzo scontato" *ngIf="pacchetto.hasSconto()">
                    <div>
                      <span class="valuta">€</span>
                      <span>
                        {{
                          pacchetto.choosePrezzoScontato() | number : "1.2-2"
                        }}
                      </span>
                    </div>
                    <div *ngIf="!pacchetto.hasSconto()">&nbsp;</div>
                  </div>
                </div>
                <span class="material-symbols-outlined mt-1">
                  shopping_cart
                </span>
              </div>
            </div>
          </ng-container>
        </a>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      pacchettoSelezionato &&
      pacchettiFiltered &&
      pacchettiFiltered.length > 0 &&
      !isMobile
    "
    class="dettaglio__vino mt-5rem hidden__mobile"
  >
    <app-dettaglio-pacchetto
      [pacchetto]="pacchettoSelezionato"
      [linguaCorrente]="linguaCorrente"
      [codiceForm]="codiceForm"
      [pacchettoSelezionato]="pacchettoSelezionato"
      [canBack]="true"
      [fromBase]="true"
      [idx]="idxSelezionato"
      (goBack)="goBack()"
    >
    </app-dettaglio-pacchetto>
  </div>
</div>
